<template>
  <a-tooltip
    placement="right"
    overlayClassName="home-upload-tooltips my-tooltips"
    title="仅支持上传mp3,flac,m4a,wav,mp4格式音频"
  >
    <div>上传文件</div>
  </a-tooltip>
</template>
